module.exports = __webpack_public_path__ + "img/normal_multiplier.c5077f52.png";